// extracted by mini-css-extract-plugin
module.exports = {"container":"InformativeAdvice_container__DBC3v","content":"InformativeAdvice_content__3Owql","paragraphs":"InformativeAdvice_paragraphs__3T93y"};